import { Component } from '@angular/core';

/**
 * The raised card that holds a page's form or content inside the auth
 * shell, as on the sign-in page.
 */
@Component({
  selector: 'app-auth-panel',
  template: '<ng-content></ng-content>',
  host: {
    class:
      'mt-8 flex flex-col gap-5 rounded-2xl bg-zinc-800 p-5 inset-ring inset-ring-zinc-750',
  },
})
export class AuthPanelComponent {}
